export const subdomainIsWidget = () => {
  let host = window.location.host
  let parts = host.split(".")
  if (parts.length >= 3) {
    const subdomain = parts[0]
    return subdomain === "widget"
  }
}
